import { RecordResponse } from "@services/http/responses/BaseResponse";
import useApiRequests from "@services/http/useApiRequest";
import { LatLngExpression } from "leaflet";
import {
  AddLocationRequest,
  EditLocationRequest,
  IAddLocationParams,
  IEditLocation,
  ILocation,
  ILocationForList,
} from "@services/locations";
import {
  addNewLocation,
  editLocation as editLocationInStore,
} from "@store/locations/actions";
import { makeNotifs } from "@utils/makeNotifs";
import moment from "moment";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { IAddLocatinProps } from "./AddLocation";
import { useSelectorLocations } from "@utils/hooks/useSelectorLocations";
import { ErrorType } from "@components/global/new/Error/Error";
import { isCurrentStr } from "@utils/isRussianLang";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";

interface Elems extends HTMLFormControlsCollection {
  name: HTMLInputElement;
  loc_id: HTMLInputElement;
  address: HTMLInputElement;
  coords: HTMLInputElement;
  notes: HTMLInputElement;
}

interface MyForm extends HTMLFormElement {
  readonly elements: Elems;
}

interface IAddLocationControl {
  readonly loading: boolean;
  readonly showEx: boolean;
  readonly errorsStr?: ErrorType;
  readonly openMapModal: boolean;
  readonly mapCoords?: LatLngExpression;

  onSubmit(e: React.FormEvent<MyForm>): void;
  setShowEx(b: boolean): void;
  setOpenMapModal(b: boolean): void;
  setMapCoords(c: LatLngExpression): void;
}

export const useAddLocationControl = (
  props: IAddLocatinProps
): IAddLocationControl => {
  const notifs = makeNotifs();
  const requests = useApiRequests();
  const locations = useSelectorLocations();
  const { onLoader, onError } = useGlobalNotifs();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [showEx, setShowEx] = useState<boolean>(false);
  const [errorsStr, setErrorsStr] = useState<ErrorType>();
  const [openMapModal, setOpenMapModal] = useState<boolean>(false);
  const [mapCoords, setMapCoords] = useState<LatLngExpression>(
    props.location?.Coord?.split(",").map((item) => +item) as LatLngExpression
  );

  // useEffect(() => {
  //   if (!errorsStr) return;
  //   const t = setTimeout(() => setErrorsStr(undefined), 500);

  //   return () => clearTimeout(t);
  // }, [errorsStr]);

  const onSubmit = async (e: React.FormEvent<MyForm>) => {
    e.preventDefault();
    setLoading(true);
    const { name, loc_id, address, notes } = e.currentTarget.elements;

    const elems = { name, loc_id, address, notes };

    for (let key in { name, loc_id }) {
      const el = elems[key as keyof typeof elems] as HTMLInputElement;
      if (el.value.length === 0) {
        setErrorsStr((prev) => ({
          ...prev,
          fill: true,
          // ownError: notifs.errors.locations__fill_fields,
        }));
        setLoading(false);
        return;
      }
    }

    setErrorsStr(undefined);

    const values: Omit<ILocation, "Id"> = {
      Name: name.value,
      Code: loc_id.value,
      Address: address.value,
      Coord: mapCoords?.toString(),
      Notes: notes.value,
      Uuid: "",
    };
    if (!isCurrentStr(values.Code)) {
      setErrorsStr({ ownError: [notifs.errors.symbols] });
      return;
    }

    const edit = props.location === undefined ? false : true;

    const isSameId = edit
      ? false
      : locations.find((item) => item.Code === loc_id.value)
        ? true
        : false;

    if (isSameId) {
      onError(notifs.errors.locations__sameId);
      setLoading(false);
      return;
    }

    const req = edit
      ? new EditLocationRequest({
        ...values,
        Id: props.location?.Id,
        edit,
      } as IEditLocation)
      : new AddLocationRequest({
        ...values,
        Id: props.location?.Id,
      } as IAddLocationParams);

    const response = await requests.enqueue<RecordResponse<string>>(req, {
      onLoadingStatusChanged: onLoader,
    });
    setLoading(false);

    if (!response) return;
    // onSuccess(notifs.ok.success);
    if (!edit) {
      dispatch(
        addNewLocation({
          ...values,
          Id: response.Record,
          Updated: moment().unix(),
          Created: moment().unix(),
        } as ILocationForList)
      );
    } else {
      dispatch(
        editLocationInStore({
          ...values,
          Id: props.location.Id,
          Updated: moment().unix(),
        } as ILocationForList)
      );
    }
    props.handleClose();
  };

  return {
    loading,
    showEx,
    errorsStr,
    openMapModal,
    mapCoords,

    onSubmit,
    setShowEx,
    setOpenMapModal,
    setMapCoords,
  };
};
